module.exports = __webpack_public_path__ + "static/media/MKR-104-badge.e6351bc3.svg";